import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withKeys as _withKeys, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14f73f17"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_inspection_steps",
  ref: "inspectionStepsModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_3 = {
  class: "modal-content stepper stepper-pills stepper-column",
  "data-kt-stepper": "true",
  ref: "inspectionStepperRef"
}
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_inspection_steps_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1))
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_11 = {
  class: "me-n7 pe-7",
  id: "kt_modal_inspection_steps_scroll",
  "data-kt-scroll": "false",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_inspection_steps_header",
  "data-kt-scroll-wrappers": "#kt_modal_inspection_steps_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_12 = { class: "d-flex flex-column flex-xl-row flex-row-fluid gap-10" }
const _hoisted_13 = { class: "stepper-nav w-300px" }
const _hoisted_14 = {
  class: "stepper-item current",
  "data-kt-stepper-element": "nav"
}
const _hoisted_15 = { class: "stepper-wrapper" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "1")
], -1))
const _hoisted_17 = { class: "stepper-label" }
const _hoisted_18 = { class: "stepper-title" }
const _hoisted_19 = { class: "stepper-desc fw-semibold" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1))
const _hoisted_21 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_22 = { class: "stepper-wrapper" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "2")
], -1))
const _hoisted_24 = { class: "stepper-label" }
const _hoisted_25 = { class: "stepper-title" }
const _hoisted_26 = { class: "stepper-desc fw-semibold" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1))
const _hoisted_28 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_29 = { class: "stepper-wrapper" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "3")
], -1))
const _hoisted_31 = { class: "stepper-label" }
const _hoisted_32 = { class: "stepper-title" }
const _hoisted_33 = { class: "stepper-desc fw-semibold" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1))
const _hoisted_35 = {
  class: "stepper-item mark-completed",
  "data-kt-stepper-element": "nav"
}
const _hoisted_36 = { class: "stepper-wrapper" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "4")
], -1))
const _hoisted_38 = { class: "stepper-label" }
const _hoisted_39 = { class: "stepper-title" }
const _hoisted_40 = { class: "stepper-desc fw-semibold" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1))
const _hoisted_42 = { class: "stepper-content w-100" }
const _hoisted_43 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_44 = { class: "w-100" }
const _hoisted_45 = { class: "form-group mb-7" }
const _hoisted_46 = { class: "form-label fw-bold" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/custom/scan_code.svg",
    class: "w-200px"
  })
], -1))
const _hoisted_48 = {
  class: "pending",
  "data-kt-stepper-element": "content"
}
const _hoisted_49 = { class: "w-100" }
const _hoisted_50 = { class: "d-flex align-items-center mb-8" }
const _hoisted_51 = { class: "symbol symbol-50px overflow-hidden me-sm-2" }
const _hoisted_52 = { class: "symbol-label bg-transparent" }
const _hoisted_53 = { class: "flex-fill" }
const _hoisted_54 = { class: "fs-6" }
const _hoisted_55 = { class: "fs-7 text-gray-400 text-line-clamp-1" }
const _hoisted_56 = { class: "flex-fill" }
const _hoisted_57 = { class: "fs-6" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "form-group mb-7" }
const _hoisted_60 = { class: "form-label fw-bold required" }
const _hoisted_61 = { class: "form-group mb-7" }
const _hoisted_62 = { class: "form-label fw-bold required" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { class: "form-label fw-bold" }
const _hoisted_65 = {
  key: 0,
  class: "form-label fw-bold d-flex"
}
const _hoisted_66 = {
  class: "d-flex align-items-center text-primary cursor-pointer",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_inspection_step_product_image"
}
const _hoisted_67 = { class: "svg-icon svg-icon-2 svg-icon-primary ms-1" }
const _hoisted_68 = { class: "pb-10" }
const _hoisted_69 = { class: "svg-icon svg-icon-4x me-4 svg-icon-success" }
const _hoisted_70 = { class: "d-block fw-semibold text-start" }
const _hoisted_71 = { class: "text-dark fw-bold d-block fs-3" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold fs-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "330",
    src: "media/svg/custom/barcode.svg"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "ms-4",
    width: "32",
    src: "media/svg/custom/scan_code.svg"
  })
], -1))
const _hoisted_73 = { class: "svg-icon svg-icon-4x svg-icon-danger me-4" }
const _hoisted_74 = { class: "d-block fw-semibold text-start" }
const _hoisted_75 = { class: "text-dark fw-bold d-block fs-3" }
const _hoisted_76 = { class: "text-muted fw-semibold fs-6" }
const _hoisted_77 = {
  class: "pending",
  "data-kt-stepper-element": "content"
}
const _hoisted_78 = { class: "w-100" }
const _hoisted_79 = { class: "d-flex align-items-center mb-8" }
const _hoisted_80 = { class: "symbol symbol-50px overflow-hidden me-sm-2" }
const _hoisted_81 = { class: "symbol-label bg-transparent" }
const _hoisted_82 = { class: "flex-fill" }
const _hoisted_83 = { class: "fs-6" }
const _hoisted_84 = { class: "fs-7 text-gray-400 text-line-clamp-1" }
const _hoisted_85 = { class: "flex-fill" }
const _hoisted_86 = { class: "fs-6" }
const _hoisted_87 = ["innerHTML"]
const _hoisted_88 = { class: "fs-7 text-gray-400 mb-8" }
const _hoisted_89 = { class: "mb-0 fv-row fv-plugins-icon-container mb-7" }
const _hoisted_90 = { class: "d-flex align-items-center form-label mb-5" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "aria-label": "Reason description",
  "data-bs-original-title": "Reason description",
  "data-kt-initialized": "1"
}, null, -1))
const _hoisted_92 = { class: "mb-0" }
const _hoisted_93 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_94 = { class: "d-flex align-items-center me-2" }
const _hoisted_95 = { class: "symbol symbol-50px me-6" }
const _hoisted_96 = { class: "symbol-label bg-light-danger" }
const _hoisted_97 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_98 = { class: "d-flex flex-column" }
const _hoisted_99 = { class: "fw-bold text-gray-800 text-hover-primary fs-5" }
const _hoisted_100 = { class: "fs-6 fw-semibold text-muted" }
const _hoisted_101 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_102 = ["value"]
const _hoisted_103 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_104 = { class: "d-flex align-items-center me-2" }
const _hoisted_105 = { class: "symbol symbol-50px me-6" }
const _hoisted_106 = { class: "symbol-label bg-light-warning" }
const _hoisted_107 = { class: "svg-icon svg-icon-1 svg-icon-warning" }
const _hoisted_108 = { class: "d-flex flex-column" }
const _hoisted_109 = { class: "fw-bold text-gray-800 text-hover-primary fs-5" }
const _hoisted_110 = { class: "fs-6 fw-semibold text-muted" }
const _hoisted_111 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_112 = ["value"]
const _hoisted_113 = { class: "d-flex flex-stack mb-0 cursor-pointer" }
const _hoisted_114 = { class: "d-flex align-items-center me-2" }
const _hoisted_115 = { class: "symbol symbol-50px me-6" }
const _hoisted_116 = { class: "symbol-label bg-light-primary" }
const _hoisted_117 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_118 = { class: "d-flex flex-column" }
const _hoisted_119 = { class: "fw-bold text-gray-800 text-hover-primary fs-5" }
const _hoisted_120 = { class: "fs-6 fw-semibold text-muted" }
const _hoisted_121 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_122 = ["value"]
const _hoisted_123 = { class: "fv-plugins-message-container invalid-feedback" }
const _hoisted_124 = { class: "upload-photos" }
const _hoisted_125 = { class: "form-label mb-0" }
const _hoisted_126 = { class: "fs-7 text-gray-400 mb-8" }
const _hoisted_127 = { class: "svg-icon svg-icon-5tx svg-icon-primary" }
const _hoisted_128 = { class: "el-upload__text" }
const _hoisted_129 = { class: "thumbnail-item" }
const _hoisted_130 = ["src"]
const _hoisted_131 = { class: "el-upload-list__item-actions" }
const _hoisted_132 = ["onClick"]
const _hoisted_133 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_134 = ["onClick"]
const _hoisted_135 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_136 = { class: "el-upload__tip" }
const _hoisted_137 = { class: "fv-plugins-message-container invalid-feedback" }
const _hoisted_138 = {
  class: "pending",
  "data-kt-stepper-element": "content"
}
const _hoisted_139 = { class: "w-100" }
const _hoisted_140 = { class: "d-flex flex-center flex-column py-10 px-10 px-lg-20 mb-10" }
const _hoisted_141 = { class: "svg-icon svg-icon-5tx svg-icon-success mb-5" }
const _hoisted_142 = { class: "text-center text-dark" }
const _hoisted_143 = { class: "fw-bold mb-5" }
const _hoisted_144 = ["innerHTML"]
const _hoisted_145 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_146 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_147 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_148 = { class: "fw-semibold" }
const _hoisted_149 = { class: "text-gray-900 fw-bold" }
const _hoisted_150 = { class: "fs-6 text-gray-700" }
const _hoisted_151 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_152 = ["disabled"]
const _hoisted_153 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_154 = ["disabled"]
const _hoisted_155 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_156 = ["disabled"]
const _hoisted_157 = { class: "indicator-label" }
const _hoisted_158 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_159 = { class: "indicator-progress" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_161 = ["disabled"]
const _hoisted_162 = { class: "svg-icon svg-icon-3" }
const _hoisted_163 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_164 = { class: "svg-icon svg-icon-3 ms-0 me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_inspection_step_product_image_modal = _resolveComponent("inspection-step-product-image-modal")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspection")) + " ", 1),
                (_ctx.inspectionInfo?.identifier_code)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/ #" + _toDisplayString(_ctx.inspectionInfo.identifier_code), 1))
                  : _createCommentVNode("", true),
                (_ctx.inspectionInfo?.order_number)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createElementVNode("span", null, " / #" + _toDisplayString(_ctx.inspectionInfo?.order_number), 1),
                      _createElementVNode("span", null, "#SUB" + _toDisplayString(_ctx.inspectionInfo?.order_item_position), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_8
            ]),
            _createElementVNode("div", {
              "data-bs-dismiss": "modal",
              class: "btn btn-icon btn-sm btn-active-icon-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
            }, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createVNode(_component_el_form, {
            onSubmit: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            "validate-on-rule-change": false,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.t("inspection.scanner")), 1),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t("inspection.scanBarcode")), 1)
                          ])
                        ]),
                        _hoisted_20
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.t("inspection.checking")), 1),
                            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t("inspection.inspectionDetails")), 1)
                          ])
                        ]),
                        _hoisted_27
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.t("inspection.exception")), 1),
                            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.t("inspection.reasonAndPhotos")), 1)
                          ])
                        ]),
                        _hoisted_34
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.t("inspection.complete")), 1),
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.t("inspection.completeSubTitle")), 1)
                          ])
                        ]),
                        _hoisted_41
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t("order.guid")), 1),
                            _createVNode(_component_el_form_item, { prop: "identifier_code" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  ref: "identifierCodeRef",
                                  modelValue: _ctx.formData.identifier_code,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.identifier_code) = $event)),
                                  modelModifiers: { trim: true },
                                  type: "text",
                                  placeholder: _ctx.t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_47
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                (_ctx.inspectionInfo?.gallery)
                                  ? (_openBlock(), _createBlock(_component_el_carousel, {
                                      key: 0,
                                      class: "w-100 h-100",
                                      "indicator-position": "none",
                                      height: "50px",
                                      autoplay: false,
                                      arrow: "never"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inspectionInfo?.gallery, (product, key) => {
                                          return (_openBlock(), _createBlock(_component_el_carousel_item, { key: key }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_image, {
                                                class: "w-100 h-100 cursor-pointer",
                                                src: 
                                    product.origin_url +
                                    '?x-oss-process=image/resize,l_200'
                                  ,
                                                fit: "contain",
                                                onClick: ($event: any) => (
                                    _ctx.previewImages(_ctx.inspectionInfo?.gallery, key)
                                  )
                                              }, null, 8, ["src", "onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.inspectionInfo?.__show.brand_id), 1),
                              _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.inspectionInfo?.name_en), 1)
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.inspectionInfo?.brand_article_no), 1),
                              _createElementVNode("div", {
                                class: "fs-7 text-gray-400",
                                innerHTML: 
                              _ctx.t('order.colorAndSize', [
                                _ctx.inspectionInfo?.__show.color,
                                _ctx.inspectionInfo?.__show.size,
                              ])
                            
                              }, null, 8, _hoisted_58)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.t("order.ean")), 1),
                            _createVNode(_component_el_form_item, { prop: "ean" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.ean,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.ean) = $event)),
                                  modelModifiers: { trim: true },
                                  type: "text",
                                  placeholder: _ctx.t('common.plsEnter'),
                                  clearable: "",
                                  onChange: _ctx.barcodeInputFocus
                                }, null, 8, ["modelValue", "placeholder", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.t("order.countryOfOrigin")), 1),
                            _createVNode(_component_el_form_item, { prop: "origin_country" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.formData.origin_country,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.origin_country) = $event)),
                                  filterable: "",
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  style: {"width":"100%"},
                                  onChange: _ctx.barcodeInputFocus
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.originCountry, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.value + '(' + item.label + ')',
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.t("inspection.sltscanBarcode")), 1),
                            (_ctx.isShowPassed)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_65, [
                                  _createElementVNode("span", _hoisted_66, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.uploadProductImage")), 1),
                                    _createElementVNode("span", _hoisted_67, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr087.svg" })
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_68, [
                              (_ctx.isShowPassed)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "btn btn-outline btn-outline-dashed btn-outline-success btn-active-light-success p-7 d-flex align-items-center mb-5 position-relative",
                                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPassedClicked && _ctx.onPassedClicked(...args)))
                                  }, [
                                    _createElementVNode("span", _hoisted_69, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                                    ]),
                                    _createElementVNode("span", _hoisted_70, [
                                      _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.t("inspection.passed")), 1),
                                      _hoisted_72,
                                      _withDirectives(_createElementVNode("input", {
                                        class: "bar-code-input",
                                        ref: "barcodeInput",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.barcode) = $event)),
                                        type: "text"
                                      }, null, 512), [
                                        [_vModelText, _ctx.barcode]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: "btn btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger p-7 d-flex align-items-center",
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFailedClicked && _ctx.onFailedClicked(...args)))
                              }, [
                                _createElementVNode("span", _hoisted_73, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen040.svg" })
                                ]),
                                _createElementVNode("span", _hoisted_74, [
                                  _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.t("inspection.failed")), 1),
                                  _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.t("inspection.failedSubTitle")), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("div", _hoisted_81, [
                                (_ctx.inspectionInfo?.gallery)
                                  ? (_openBlock(), _createBlock(_component_el_carousel, {
                                      key: 0,
                                      class: "w-100 h-100",
                                      "indicator-position": "none",
                                      height: "50px",
                                      autoplay: false,
                                      arrow: "never"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inspectionInfo?.gallery, (product, key) => {
                                          return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                            key: key,
                                            class: "d-flex justify-content-center align-items-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_image, {
                                                class: "w-100 h-100 cursor-pointer",
                                                src: 
                                    product.origin_url +
                                    '?x-oss-process=image/resize,l_200'
                                  ,
                                                fit: "contain",
                                                onClick: ($event: any) => (
                                    _ctx.previewImages(_ctx.inspectionInfo?.gallery, key)
                                  )
                                              }, null, 8, ["src", "onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.inspectionInfo?.__show.brand_id), 1),
                              _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.inspectionInfo?.name_en), 1)
                            ]),
                            _createElementVNode("div", _hoisted_85, [
                              _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.inspectionInfo?.brand_article_no), 1),
                              _createElementVNode("div", {
                                class: "fs-7 text-gray-400",
                                innerHTML: 
                              _ctx.t('order.colorAndSize', [
                                _ctx.inspectionInfo?.__show.color,
                                _ctx.inspectionInfo?.__show.size,
                              ])
                            
                              }, null, 8, _hoisted_87)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_88, _toDisplayString(_ctx.t("inspection.onlySimplePhotosProvided")), 1),
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("label", _hoisted_90, [
                              _createTextVNode(_toDisplayString(_ctx.t("inspection.reason")) + " ", 1),
                              _hoisted_91
                            ]),
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("label", _hoisted_93, [
                                _createElementVNode("span", _hoisted_94, [
                                  _createElementVNode("span", _hoisted_95, [
                                    _createElementVNode("span", _hoisted_96, [
                                      _createElementVNode("span", _hoisted_97, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen040.svg" })
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("span", _hoisted_98, [
                                    _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.t("inspection.incorrectArticle")), 1),
                                    _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.t("inspection.incorrectArticle")), 1)
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_101, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    name: "reason",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.reason) = $event)),
                                    value: _ctx.InspectionReason.IncorrectArticle
                                  }, null, 8, _hoisted_102), [
                                    [_vModelRadio, _ctx.formData.reason]
                                  ])
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_103, [
                                _createElementVNode("span", _hoisted_104, [
                                  _createElementVNode("span", _hoisted_105, [
                                    _createElementVNode("span", _hoisted_106, [
                                      _createElementVNode("span", _hoisted_107, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen063.svg" })
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("span", _hoisted_108, [
                                    _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.t("inspection.damagedArticlePackaging")), 1),
                                    _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.t("inspection.damagedArticlePackaging")), 1)
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_111, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    name: "reason",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.reason) = $event)),
                                    value: 
                                  _ctx.InspectionReason.DamagedArticlePackaging
                                
                                  }, null, 8, _hoisted_112), [
                                    [_vModelRadio, _ctx.formData.reason]
                                  ])
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_113, [
                                _createElementVNode("span", _hoisted_114, [
                                  _createElementVNode("span", _hoisted_115, [
                                    _createElementVNode("span", _hoisted_116, [
                                      _createElementVNode("span", _hoisted_117, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspection-2nd.svg" })
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("span", _hoisted_118, [
                                    _createElementVNode("span", _hoisted_119, _toDisplayString(_ctx.t("inspection.secondInspectionRequired")), 1),
                                    _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.t("inspection.secondInspectionRequired")), 1)
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_121, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    name: "reason",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.reason) = $event)),
                                    value: 
                                  _ctx.InspectionReason.SecondInspectionRequired
                                
                                  }, null, 8, _hoisted_122), [
                                    [_vModelRadio, _ctx.formData.reason]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_123, _toDisplayString(_ctx.reasonErrorMessage), 1)
                          ]),
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("label", _hoisted_125, _toDisplayString(_ctx.t("inspection.uploadPhotos")), 1),
                            _createElementVNode("p", _hoisted_126, _toDisplayString(_ctx.t("inspection.photosRequired")), 1),
                            _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                              ref: "uploadRef",
                              class: _normalizeClass(["multiple-drag-upload bg-light-primary rounded border-primary border border-dashed", { hasfile: _ctx.fileList.length > 0 }]),
                              drag: "",
                              multiple: "",
                              "file-list": _ctx.fileList,
                              "auto-upload": false,
                              "show-file-list": true,
                              accept: ".jpg,.jpeg,.png",
                              headers: _ctx.uploadHeaders,
                              "on-change": _ctx.onUploadChange,
                              "on-error": _ctx.onUploadError
                            }, {
                              file: _withCtx(({ file }) => [
                                _createElementVNode("div", _hoisted_129, [
                                  _createElementVNode("img", {
                                    class: "el-upload-list__item-thumbnail",
                                    src: file.url,
                                    alt: ""
                                  }, null, 8, _hoisted_130),
                                  _createElementVNode("span", _hoisted_131, [
                                    _createElementVNode("span", {
                                      class: "el-upload-list__item-preview",
                                      onClick: ($event: any) => (_ctx.handlePreview(file))
                                    }, [
                                      _createElementVNode("span", _hoisted_133, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen004.svg" })
                                      ])
                                    ], 8, _hoisted_132),
                                    _createElementVNode("span", {
                                      class: "el-upload-list__item-delete",
                                      onClick: ($event: any) => (_ctx.handleRemove(file))
                                    }, [
                                      _createElementVNode("span", _hoisted_135, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr015.svg" })
                                      ])
                                    ], 8, _hoisted_134)
                                  ])
                                ])
                              ]),
                              tip: _withCtx(() => [
                                _createElementVNode("div", _hoisted_136, _toDisplayString(_ctx.t("common.uploadAcceptSize", [
                                  "jpg/png",
                                  "100M",
                                ])), 1)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_127, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil022.svg" })
                                ]),
                                _createElementVNode("div", _hoisted_128, [
                                  _createTextVNode(_toDisplayString(_ctx.t("common.uploadDrop")) + " ", 1),
                                  _createElementVNode("em", null, _toDisplayString(_ctx.t("common.uploadClick")), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["class", "file-list", "headers", "on-change", "on-error"])), [
                              [_directive_loading, _ctx.uploadLoading]
                            ]),
                            _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.uploadErrorMessage), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_138, [
                        _createElementVNode("div", _hoisted_139, [
                          _createElementVNode("div", _hoisted_140, [
                            _createElementVNode("span", _hoisted_141, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                            ]),
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("h1", _hoisted_143, _toDisplayString(_ctx.t("inspection.completeSubTitle")) + "! ", 1),
                              _createElementVNode("p", {
                                innerHTML: _ctx.t('inspection.ifNeedMoreInfo')
                              }, null, 8, _hoisted_144)
                            ])
                          ]),
                          (_ctx.formData.reason !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                _createElementVNode("span", _hoisted_146, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                ]),
                                _createElementVNode("div", _hoisted_147, [
                                  _createElementVNode("div", _hoisted_148, [
                                    _createElementVNode("h4", _hoisted_149, _toDisplayString(_ctx.t("inspection.needAttention")), 1),
                                    _createElementVNode("div", _hoisted_150, _toDisplayString(_ctx.t("inspection.needAttentionSubTitle")), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              (_ctx.activeStepIndex !== 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                    (_ctx.activeStepIndex == 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-lg btn-primary me-3",
                          "data-kt-stepper-action": "next",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onContinueClicked && _ctx.onContinueClicked(...args))),
                          onKeyup: _cache[11] || (_cache[11] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onContinueClicked && _ctx.onContinueClicked(...args)), ["enter"])),
                          disabled: _ctx.disabledContinue
                        }, [
                          _createElementVNode("span", _hoisted_153, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.continue")), 1)
                        ], 40, _hoisted_152))
                      : _createCommentVNode("", true),
                    (_ctx.activeStepIndex == 3)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-lg btn-light-primary me-3",
                          "data-kt-stepper-action": "previous",
                          disabled: _ctx.uploadLoading,
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.goPrevStep && _ctx.goPrevStep(...args)))
                        }, [
                          _createElementVNode("span", _hoisted_155, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
                        ], 8, _hoisted_154))
                      : _createCommentVNode("", true),
                    (_ctx.activeStepIndex == 3)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          ref: "submitButton",
                          type: "submit",
                          class: "btn btn-lg btn-primary",
                          disabled: _ctx.uploadLoading
                        }, [
                          _createElementVNode("span", _hoisted_157, [
                            _createElementVNode("span", _hoisted_158, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.next")), 1)
                          ]),
                          _createElementVNode("span", _hoisted_159, [
                            _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                            _hoisted_160
                          ])
                        ], 8, _hoisted_156))
                      : _createCommentVNode("", true),
                    (_ctx.activeStepIndex == 4)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          type: "button",
                          class: "btn btn-bg-light btn-active-color-primary me-3",
                          disabled: _ctx.options.printLoading,
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.getPrintedSheet && _ctx.getPrintedSheet(...args)))
                        }, [
                          _createElementVNode("span", _hoisted_162, [
                            _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/print.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.print")), 1)
                        ], 8, _hoisted_161))
                      : _createCommentVNode("", true),
                    (_ctx.activeStepIndex == 4)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          type: "button",
                          class: "btn btn-lg btn-light-primary me-3",
                          "data-bs-dismiss": "modal",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
                        }, [
                          _createElementVNode("span", _hoisted_163, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.close")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.activeStepIndex == 4)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          type: "button",
                          class: "btn btn-lg btn-primary",
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.startNewScan && _ctx.startNewScan(...args)))
                        }, [
                          _createElementVNode("span", _hoisted_164, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.closeAndNewScan")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ], 512)
      ])
    ], 512),
    _createVNode(_component_inspection_step_product_image_modal, {
      files: _ctx.fileList,
      infoData: _ctx.formData,
      fileUploads: _ctx.uploadList,
      onSubmitForm: _ctx.productImageSubmitForm,
      onUpdateList: _ctx.productImageUpdateList,
      onResetForm: _ctx.closeProductImageModal
    }, null, 8, ["files", "infoData", "fileUploads", "onSubmitForm", "onUpdateList", "onResetForm"]),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}